import { CustomTranslateLoaderService } from './_services/custom-translate-loader.service';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
//import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';

import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { Downloader } from '@ionic-native/downloader/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';

import { AuthLayoutComponent } from './_layouts/authentication/authlayout.component';
import { HomeLayoutComponent } from './_layouts/home/home-layout.component';
import { CustomHttpInterceptor } from './_services/customhttpinterceptor.service';
import { AuthenticationService } from './_services';
import { Camera } from '@ionic-native/camera/ngx';
import { AppModalsModule } from './_modals/app.modals.module';

import { AppVersion } from '@ionic-native/app-version/ngx';

import { HTTP } from '@ionic-native/http/ngx';
import { FullScreenLayout } from './_layouts/fullscrn/fullscrn-layout';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from './_constants/translate-http-loader';
import { SharedModule } from './_shared/shared.module';
import { LibModule } from './_libs/lib.module';
import { Device } from '@ionic-native/device/ngx';





export function init_app(authService: AuthenticationService) {
  return () => {
    
  };
}

@NgModule({
  imports: [
    BrowserModule,
  // BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    LibModule,
    SharedModule,
    AppModalsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        // useFactory: HttpLoaderFactory,
        useClass: CustomTranslateLoaderService,
        deps: [HttpClient]
    }
    })
    ],
  declarations: [AppComponent, AuthLayoutComponent, HomeLayoutComponent, FullScreenLayout],
  providers: [
    InAppBrowser, StatusBar, Camera, AppVersion, HTTP,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true
    },
    FileTransfer, File, AndroidPermissions, FileOpener,
    Downloader,
    { provide: APP_INITIALIZER, useFactory: init_app, deps: [AuthenticationService], multi: true },
    Device
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
